import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warn",
  "use": "icon-warn-usage",
  "viewBox": "0 0 32 28.33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 28.33\" id=\"icon-warn\"><defs><style>#icon-warn .cls-1{fill:#ea5514;}</style></defs><title>资源 3</title><g id=\"icon-warn_图层_2\" data-name=\"图层 2\"><g id=\"icon-warn_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M31.85,26.63,17,.58a1.17,1.17,0,0,0-2,0L.15,26.63a1.14,1.14,0,0,0,1,1.7h29.7a1.15,1.15,0,0,0,1-.56A1.13,1.13,0,0,0,31.85,26.63ZM17.83,25H14.17V21.67h3.66Zm0-5.83H14.17v-10h3.66Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol